
type H1Type = {
    text: string
}
const  H1 = ({text} : H1Type) => {

    return <h1 className="text-xl font-medium text-slate-900 dark:text-navy-50 lg:text-2xl">{text}</h1>;

}

export default H1;
